import React, { useRef, useState, useEffect } from 'react';
import * as call from '../../../call';
import { SELF_PARTICIPANT_ID } from '../../constants';
import { ParticipantVideo } from './ParticipantVideo';
import { ParticipantPlaceholder } from './ParticipantPlaceholder';
import './MainView.scss';
const stubParticipant = () => ({});
export const MainView = ({ activeParticipant, currentParticipant, onChangeCurrentParticipant, }) => {
    if (!activeParticipant || !currentParticipant) {
        return null;
    }
    const [firstParticipant, setFirstParticipant] = useState(stubParticipant());
    const [secondParticipant, setSecondParticipant] = useState(stubParticipant());
    const [screenParticipant, setScreenParticipant] = useState(stubParticipant());
    const firstVideoRef = useRef();
    const secondVideoRef = useRef();
    useEffect(() => {
        if (activeParticipant.streamType === call.constants.StreamType.Screen) {
            if (activeParticipant.id === screenParticipant.id) {
                onChangeCurrentParticipant(screenParticipant);
                return;
            }
            setScreenParticipant(activeParticipant);
            return;
        }
        // @TODO remove this condition when the hasVideo reflects real state. Currently it doesn't match when user doesn't give access to the camera (hasCameraAccess is false)
        if (activeParticipant.id === SELF_PARTICIPANT_ID &&
            !activeParticipant.hasCameraAccess) {
            onChangeCurrentParticipant(activeParticipant);
            return;
        }
        if (!activeParticipant.hasVideo) {
            onChangeCurrentParticipant(activeParticipant);
            return;
        }
        if (activeParticipant.id === firstParticipant.id) {
            return firstVideoRef.current.play();
        }
        if (activeParticipant.id === secondParticipant.id) {
            return secondVideoRef.current.play();
        }
        if (currentParticipant.id === firstParticipant.id) {
            return setSecondParticipant(activeParticipant);
        }
        setFirstParticipant(activeParticipant);
    }, [
        activeParticipant.id,
        activeParticipant.streamType,
        activeParticipant.hasVideo,
    ]);
    const isFirstVideoActive = currentParticipant.id === firstParticipant.id &&
        currentParticipant.hasVideo;
    const isSecondVideoActive = currentParticipant.id === secondParticipant.id &&
        currentParticipant.hasVideo;
    const isScreenVideoActive = currentParticipant.id === screenParticipant.id &&
        currentParticipant.hasVideo;
    return (<div className="ml-main-view">
      <div className="ml-main-view__videos">
        <ParticipantVideo className="first" ref={firstVideoRef} onPlay={onChangeCurrentParticipant} active={isFirstVideoActive} participant={firstParticipant}/>
        <ParticipantVideo className="second" onPlay={onChangeCurrentParticipant} ref={secondVideoRef} active={isSecondVideoActive} participant={secondParticipant}/>
        <ParticipantVideo className="screen" onPlay={onChangeCurrentParticipant} active={isScreenVideoActive} participant={screenParticipant}/>
      </div>

      {!currentParticipant.hasVideo && (<ParticipantPlaceholder participant={currentParticipant}/>)}
    </div>);
};
export default MainView;
